const topics = [
  { id: 1, title: '韩漫人气TOP100', desc: '收录最受欢迎的韩国漫画', count: '1,256部', color: 'bg-primary-100 text-primary-700', icon: 'ri-fire-line' },
  { id: 2, title: '日漫经典殿堂', desc: '不可错过的日本漫画名作', count: '892部', color: 'bg-accent-100 text-accent-700', icon: 'ri-star-line' },
  { id: 3, title: '热血战斗专场', desc: '燃爆肾上腺素的热血之作', count: '2,340部', color: 'bg-primary-100 text-primary-700', icon: 'ri-sword-line' },
  { id: 4, title: '甜蜜恋爱合集', desc: '甜到牙疼的浪漫故事', count: '1,870部', color: 'bg-accent-100 text-accent-700', icon: 'ri-heart-line' },
  { id: 5, title: '悬疑推理馆', desc: '烧脑反转让你欲罢不能', count: '645部', color: 'bg-secondary-200 text-secondary-800', icon: 'ri-search-eye-line' },
  { id: 6, title: '新番速递', desc: '第一时间追更最新连载', count: '328部', color: 'bg-primary-100 text-primary-700', icon: 'ri-rocket-line' },
  { id: 7, title: '完结佳作', desc: '一口气读完的完整作品', count: '4,120部', color: 'bg-accent-100 text-accent-700', icon: 'ri-check-double-line' },
  { id: 8, title: '武侠修真录', desc: '快意恩仇的武侠世界', count: '1,093部', color: 'bg-secondary-200 text-secondary-800', icon: 'ri-empathize-line' },
  { id: 9, title: '恐怖惊悚夜', desc: '胆小慎入的惊悚漫画', count: '456部', color: 'bg-primary-100 text-primary-700', icon: 'ri-ghost-line' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">专题合集</h2>
          <p className="mt-2 text-sm text-foreground-500">按你的口味，找到最对味的漫画</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {topics.map((topic) => (
            <a key={topic.id} href="#cards" className="group flex items-center gap-4 p-5 rounded-xl bg-background-100 hover:bg-background-200/70 transition-colors cursor-pointer border border-background-200/50">
              <div className={`w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0 ${topic.color}`}>
                <i className={`${topic.icon} text-xl`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors">{topic.title}</h3>
                <p className="text-xs text-foreground-500 mt-0.5 line-clamp-1">{topic.desc}</p>
              </div>
              <span className="text-xs text-foreground-400 whitespace-nowrap flex-shrink-0">{topic.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}